import styled, {css} from 'styled-components'

export const UserInfoLabel = styled.p`
    cursor: default;
    margin-bottom: 6px;
    font-size: 14px;
    color: #222;
    margin-top: 8px;
`

export const FlexLayout = styled.div`
    display: flex;
    align-items: center;

    @media screen and (max-width: 767px) {
        flex-direction: column;
        align-items: flex-end;
        width: 100% !important;
    }
`

const userInfoStyle = css`
    padding: 10px 12px;
    width: 470px;
    font-size: 14px;
    font-weight: 500;
    color: #646464;
    border: solid 1px #dcdcdc;
    border-radius: 2px;

    @media screen and (max-width: 767px) {
        width: 100%;
    }
`

export const UserInfoText = styled.p`
    ${userInfoStyle};
    cursor: default;
`

export const UserInfoInput = styled.input`
    outline: none;
    ${userInfoStyle};
    font-family: 'roboto', sans-serif !important;
`

export const ChangeButton = styled.button`
    outline: none;
    border: none;
    background: none;
    color: #727b88;
    margin-left: 15px;
    font-size: 13px;
    cursor: pointer;

    @media screen and (max-width: 767px) {
        margin-top: 8px;
    }
`

export const EditActions = styled.div`
    display: flex;
    margin-top: 8px;
    width: 470px;

    @media screen and (max-width: 767px) {
        width: 100%;
    }
`

export const Submit = styled.span`
    background-color: #e3f2d4;
    border-radius: 2px;
    padding: 6px 18px;
    cursor: pointer;
    color: #222;
    font-size: 12px;
    margin-left: auto;
`

export const Cancel = styled.span`
    margin-left: 8px;
    margin-right: 20px;
    cursor: pointer;
    background-color: #fae7e5;
    border-radius: 2px;
    padding: 6px 18px;
    font-size: 12px;
    color: #222;
`

export const Select = styled.select`
    outline: none;
    width: 494px;
    border: solid 1px #dcdcdc;
    font-size: 14px;
    font-weight: bold;
    padding: 10px 12px;
    color: #222;
    color: #646464;
    font-family: 'roboto', sans-serif !important;

    @media screen and (max-width: 767px) {
        width: 100%;
    }
`
export const Option = styled.option``